import AddressResourceModel from '../../generated/types/model/resource/AddressResourceModel';

export default class AddressResourceViewModel extends AddressResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
